// Lib
import React, { useMemo } from 'react';

// Components
import Layout from '../../../components/Layout';
import Header from '../../../components/Cart/Header';
import OrderInfo from '../../../components/Cart/ReviewOrder/OrderInfo';
import FooterButtons from '../../../components/Cart/ShippingDetails/FooterButtons';

// Hooks
import useReviewOrder from '../hooks/useReviewOrder';

// Utils
import { getErrorString } from '../../../utils/apiErrors';

import { useStyles } from './ReviewOrderStyles';

const ReviewOrder = () => {
  const {
    shippingDetails,
    goToSippingDetails,
    cart,
    placeOrder,
    loading,
    onChangeInstructions,
    placedOrder,
    moreThanInStock,
    apiError,
    withOverLimitRequest,
    disabledCountBtn,
    isAvailableMethod,
  } = useReviewOrder();

  const isPlacedOrder = useMemo(() => !!placedOrder?.id, [placedOrder]);

  const { classes } = useStyles({ isPlacedOrder });

  return (
    <Layout
      className={{ layout: classes.layout }}
      renderComponent={() => <Header empty={!!placedOrder?.id} />}>
      <OrderInfo
        cart={cart}
        placedOrder={placedOrder}
        shippingDetails={shippingDetails}
        goToSippingDetails={goToSippingDetails}
        onChangeInstructions={onChangeInstructions}
        withOverLimitRequest={withOverLimitRequest}
        disabledCountBtn={disabledCountBtn}
        isAvailableMethod={isAvailableMethod}
        moreThanInStock={moreThanInStock}
      />
      {apiError && (
        <span className={classes.apiError}>{getErrorString(apiError)}</span>
      )}
      <FooterButtons
        withPrevButton={!placedOrder.id}
        loading={loading}
        nextButtonDisabled={moreThanInStock || !isAvailableMethod}
        nextTitle={placedOrder.id ? 'Continue Shopping' : 'Place Order'}
        backTitle="Shipping Details"
        onClickBack={goToSippingDetails}
        onClickNext={placeOrder}
      />
    </Layout>
  );
};

export default ReviewOrder;
